import { headingText } from '../../utils/headingText';
import { ArrowUpRight } from 'lucide-react';
import { bookingUrl } from '../../data/services';
export default function CTASection() {
  return <section className="home-wrap home-section final-cta"><h2>{headingText("What’s next for your mission?")}</h2><p>Let’s connect your priorities to a practical plan.</p><a className="action-dark" href={bookingUrl} target="_blank" rel="noopener noreferrer">Book a free discovery call <ArrowUpRight size={18} /></a></section>;
}
